import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";

const BriefIntro = () => {
  const sectionRef = useRef(null);
  const iframeRef = useRef(null);
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);

  // Load iframe on scroll into view
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isIframeLoaded) {
          setIsIframeLoaded(true); // lazy load iframe
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, [isIframeLoaded]);

  // Auto play/pause video when visible
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const iframe = iframeRef.current;
        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.postMessage(
            JSON.stringify({
              event: "command",
              func: entry.isIntersecting ? "playVideo" : "pauseVideo",
              args: [],
            }),
            "*"
          );
        }
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, [isIframeLoaded]);

  return (
    <div>
      <style>{`
        .brief-wrapper {
          background: linear-gradient(135deg, #18336c 0%, #4f6fa3 100%);
          color: #ffffff;
          padding: 3rem 1.5rem;
          min-height: 70vh;
          display: flex;
          align-items: center;
        }

        .brief-container {
          display: flex;
          flex-direction: column;
          gap: 2rem;
          margin: 0 auto;
        }

        @media (min-width: 768px) {
          .brief-container {
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
          }
        }

        .brief-video {
          flex: 1;
          width: 100%;
          max-width: 600px;
          position: relative;
          aspect-ratio: 16 / 9;
          cursor: pointer;
        }

        .brief-video img,
        .brief-video iframe {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border-radius: 12px;
          object-fit: cover;
        }

        .brief-video::after {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 3rem;
          color: white;
          text-shadow: 0 0 10px black;
          pointer-events: none;
        }

        .brief-text {
          flex: 1;
          width: 100%;
        }

        .brief-text h4 {
          color: white;
          font-size: 1.5rem;
          margin-bottom: 1rem;
        }

        .brief-text p {
          line-height: 1.6;
          color: #e6e6e6;
          margin-bottom: 1rem;
        }

        .brief-button {
          margin-top: 1rem;
        }

        @media (min-width: 768px) {
          .brief-button {
            display: flex;
            justify-content: flex-start;
          }
        }
      `}</style>

      <section className="brief-wrapper" ref={sectionRef}>
        <div className="brief-container container">
          {/* Video Section */}
          <div className="brief-video">
            {isIframeLoaded ? (
              <iframe
                ref={iframeRef}
                src="https://www.youtube.com/embed/yo5aL4Plbso?enablejsapi=1&mute=1"
                title="Brief Introduction Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            ) : (
              <img
                src="https://img.youtube.com/vi/yo5aL4Plbso/hqdefault.jpg"
                alt="Brief Video Thumbnail"
              />
            )}
          </div>

          {/* Text Section */}
          <div className="brief-text">
            <h4>
              The Fastest-Growing Web Development and Digital Marketing Company in the UK
            </h4>
            <p>
              Warrgyizmorsch is the UK's fastest-growing digital marketing and web development company that brings innovative and effective solutions. Our professionals create responsive, user-friendly websites according to your business requirements, and you are the buzz of the town in the competitive digital arena.
            </p>

            <div className="btn-group brief-button">
              <NavLink to="/contact-us" className="th-btn style6 style-radius">
                Contact Us
              </NavLink>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BriefIntro;
